// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-container {
  height: 500px;
  width: 100%;
}

.leaflet-pane {
  z-index: 0 !important;
}
.leaflet-top, .leaflet-bottom {
  z-index: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Minds/Minds.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB","sourcesContent":[".leaflet-container {\n  height: 500px;\n  width: 100%;\n}\n\n.leaflet-pane {\n  z-index: 0 !important;\n}\n.leaflet-top, .leaflet-bottom {\n  z-index: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
